/**
 * ⋯ more actions 菜单面板(无壳,pickers.tsx 同模式:宿主负责浮层壳)。
 * Row 用 .nvc-mini 包裹、FlyoutCard 当 body 子视图,互斥开关由宿主 state 承担。
 * 前三项均为只读自助入口,不受打卡权限(WEB_CLOCK_PERM)限制。
 * 第四项「报告平台 Bug」跳出去到 Nova UAT Platform,同样不受权限限制 ——
 * 软件坏了这件事,谁撞见谁都该能报。
 * Spec: docs/superpowers/specs/2026-06-12-clock-panel-more-actions-design.md
 */
import {
  Bug,
  CalendarDays,
  ChevronLeft,
  ClipboardList,
  ListChecks,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import "./clock-panel.css";

/** 由 SidebarClockFooter 组装下发;null = 宿主不渲染 ⋯ 入口(登录态未就绪)。 */
export interface MoreActionsConfig {
  onMyShift: () => void;
  onTimesheet: () => void;
  onDailyWork: () => void;
  /**
   * 报告**这套软件本身**的 bug —— 不是维修单、不是客诉。
   * 文案必须点明是 App/平台,只写 "report issue" 会和业务上报混起来。
   */
  onReportBug: () => void;
}

export interface ClockMoreMenuProps {
  actions: MoreActionsConfig;
  /** 选中任一项 / 点 Back 后由宿主收起浮层(Row pop)或子视图(FlyoutCard view)。
   * Back 与菜单项均不受打卡 pending/busy 禁用(只读自助入口),宿主在登录态未就绪时传 moreActions=null 即可隐藏入口。 */
  onClose: () => void;
}

export function ClockMoreMenu({ actions, onClose }: ClockMoreMenuProps) {
  const { t } = useTranslation("shifts");
  const pick = (fn: () => void) => () => {
    fn();
    onClose();
  };
  return (
    <div className="nvc-body">
      <button className="nvc-back" onClick={onClose}>
        <ChevronLeft size={11} />
        {t("attendanceClock.backMore")}
      </button>
      <button className="nvc-strow" onClick={pick(actions.onMyShift)}>
        <CalendarDays size={14} />
        <span className="nvc-stlabel">{t("attendanceClock.myShift")}</span>
      </button>
      <button className="nvc-strow" onClick={pick(actions.onTimesheet)}>
        <ClipboardList size={14} />
        <span className="nvc-stlabel">{t("attendanceClock.timesheet")}</span>
      </button>
      <button className="nvc-strow" onClick={pick(actions.onDailyWork)}>
        <ListChecks size={14} />
        <span className="nvc-stlabel">{t("attendanceClock.dailyWork")}</span>
      </button>
      {/* 放在最后一项:前三项是「我的班次/工时」这一类自助查询,这一项是
          跳出系统去报 bug,不同类,所以排在末尾而不是插在中间。 */}
      <button className="nvc-strow" onClick={pick(actions.onReportBug)}>
        <Bug size={14} />
        <span className="nvc-stlabel">{t("attendanceClock.reportBug")}</span>
      </button>
    </div>
  );
}
